import { SoundSlider } from "@kalyzee/kalyzee-ui"
import { useStudentContext } from "../../pages/master/student/context"
import { useEffect, useState } from "react";

export const AppSoundSlider = () => {
  const appCtx = useStudentContext();

  const [premuteValue, setPremuteValue] = useState(0);

  useEffect(() => {
    if (appCtx?.volume) {
      setPremuteValue(0);
    }
  }, [appCtx?.volume]);

  if (!appCtx || appCtx.volume === -1) return null;

  return (
    <SoundSlider
      min={0}
      max={100}
      value={appCtx.volume}
      step={1}
      style={{ fontSize: "0.75em" }}
      onChange={appCtx.setVolume}
      onMute={() => {
        if (appCtx.volume) {
          setPremuteValue(appCtx.volume);
          appCtx.setVolume(0);
        }  else {
          appCtx.setVolume(premuteValue || 50);
        }
      }}
    />
  )
}